import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircle, Menu } from 'lucide-react';

const Navbar9 = ({ backPath = '/projects' }) => {
  const navigate = useNavigate();
  
  // Add responsive state
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  
  // Track window resize
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
      if (window.innerWidth >= 768) setShowMobileMenu(false);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const isMobile = windowWidth < 768;

  return (
    <>
      <nav className="flex flex-col bg-white border-b">
        {/* Main row */}
        <div className="flex items-center justify-between p-4 md:p-6 w-full">
          <div className="text-xl md:text-2xl font-bold text-black truncate max-w-[200px] md:max-w-none">
            Shared With You
          </div>
          
          <div className="flex items-center space-x-2 md:space-x-4">
            {/* Desktop controls */}
            {!isMobile && (
              <>
                <button
                  onClick={() => navigate(backPath)}
                  className="text-gray-600 hover:text-black transition-colors duration-200"
                  title="Close"
                >
                  <XCircle size={24} />
                </button>
              </>
            )}
            
            {/* Mobile menu toggle */}
            {isMobile && (
              <button
                onClick={() => setShowMobileMenu(!showMobileMenu)}
                className="text-gray-600 hover:text-black transition-colors duration-200 ml-2"
                aria-label={showMobileMenu ? "Close menu" : "Open menu"}
              >
                <Menu size={24} />
              </button>
            )}
          </div>
        </div>
        
        {/* Mobile dropdown */}
        {isMobile && showMobileMenu && (
          <div className="flex flex-col p-4 border-t bg-gray-50 animate-fade-in-down">
            <button
              onClick={() => navigate(backPath)}
              className="flex items-center justify-between p-3 bg-gray-100 hover:bg-gray-200 rounded"
            >
              <span>Close</span>
              <XCircle size={20} />
            </button>
          </div>
        )}
        
        {/* Fade-in animation */}
        <style>{`
          @keyframes fadeInDown {
            from {
              opacity: 0;
              transform: translateY(-10px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
          .animate-fade-in-down {
            animation: fadeInDown 0.2s ease-out;
          }
        `}</style>
      </nav>
    </>
  );
};

export default Navbar9;